import { render, staticRenderFns } from "./commonKeyword.vue?vue&type=template&id=6f6b6b9c&scoped=true"
import script from "./commonKeyword.vue?vue&type=script&lang=js"
export * from "./commonKeyword.vue?vue&type=script&lang=js"
import style0 from "./commonKeyword.vue?vue&type=style&index=0&id=6f6b6b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b6b9c",
  null
  
)

export default component.exports